import { useEffect } from "react";

export const DisableMode = () => {
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    function ctrlShiftKey(e: KeyboardEvent, key: string) {
      return e.ctrlKey && e.shiftKey && e.key === key;
    }

    document.onkeydown = (e: KeyboardEvent) => {
      if (
        e.key === "F12" ||
        ctrlShiftKey(e, "I") ||
        ctrlShiftKey(e, "J") ||
        ctrlShiftKey(e, "C") ||
        ctrlShiftKey(e, "Ctrl") ||
        ctrlShiftKey(e, "Shift") ||
        (e.ctrlKey && e.key === "U")
      )
        return false;
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return null; // ← important
};
